const clientelocalStorage = localStorage.getItem("cliente");
const cliente = clientelocalStorage ? JSON.parse(clientelocalStorage) : null;

const VEHICULOS_BY_CLIENTE_HARDCODED = [
  { idVehiculo: 11813, idCliente: 28063, numero: "1", patente: "AA207IB" },
  { idVehiculo: 11813, idCliente: 28063, numero: "2", patente: "MAG909" },
  { idVehiculo: 11813, idCliente: 28063, numero: "3", patente: "AG234LB" },
  { idVehiculo: 11813, idCliente: 28063, numero: "4", patente: "AD407SD" },
];

export const vehiculosByCliente = async (idCliente = cliente?.idCliente) => {
  if (!idCliente) return { data: [] };

  return {
    data: idCliente === 3 ? VEHICULOS_BY_CLIENTE_HARDCODED : [],
  };
};
